import { columns } from './columns'
import createState from '../_defaults/state'
import createGetters from '../_defaults/getters'
import createMutations from '../_defaults/mutations'
import createActions from '../_defaults/actions'

/* -------- CONFIG ----------- */
export const apiEndpoint = '/api/address'
export const namespace = 'address'
export const clientRoute = '/address'
export const dependencies = ['country', 'state']
export const params = {
  include: 'Country,State'
}
/* --------------------------- */

/* -------- LABELS ----------- */
const titleColumn = 'line1'
const subtitleColumn = 'cityStateZip'
const infoColumns = ['description']
/* --------------------------- */

const state = {
  columns,
  apiEndpoint,
  namespace,
  dependencies,
  clientRoute,
  params,
  titleColumn,
  subtitleColumn,
  infoColumns
}

export default {
  namespaced: true,
  state: createState(Object.assign(state, { namespace })),
  getters: createGetters(),
  mutations: createMutations(),
  actions: createActions()
}
